module.exports = __webpack_public_path__ + "static/media/basketball.26a88bbe.jpg";